import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import MainLayout from './../../mainLayout'
import TextField from './../../component/TextField'
import Loader from '../../component/loader'
import AddFileIcon from './../../icons/plusicon';
import CopyIcon from './../../icons/copyicon';
import TextEditor from '../../component/TextEditor'
import { Player, ControlBar, PlayToggle } from "video-react";
import DeletefileIcon from "./../../icons/DeletefileIcon";

//moment import
import moment from "moment-timezone";
//import AWS from "aws-sdk";
import AWS from "aws-sdk";

//Validation import
import SimpleReactValidator from "simple-react-validator";

import PlusIcon from './../../icons/plusicon'
//Service import
import service from "../../services";
// Editors
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import { convertFromRaw } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import PopUpCustomAll from '../../component/fpg/create/popUpCustomAll'
import VideoOnlyUpload from '../VideoOnlyUpload'
import commonImage from '../../commonImage'

let sub;

const content = {
    entityMap: {},
    blocks: [
        {
            key: "637gr",
            text: "Initialized from content state.",
            type: "unstyled",
            depth: 0,
            inlineStyleRanges: [],
            entityRanges: [],
            data: {},
        },
    ],
};
export default class FestHeaderOnline extends Component {
    constructor(props) {
        super(props)

        this.state = {
            previewRecordEvents: [],
            activetab: 0,
            loaderFlag: false,
            imagePreloader: false,
            getAllHowToFestdetails: '',
            editorState: EditorState.createEmpty(),
            description: EditorState.createEmpty(),
            title: '',
            videoPreLoader: false,
            data: [
                {
                    "label": "Add/Edit Content",
                    "Content": "",
                },
            ]
        }
        this.validator = new SimpleReactValidator({ autoForceUpdate: this });
        this.apiserve = new service();
    }

    componentDidMount() {
        this.getHowToFestHeader();
        this.getHowToFestHeaderEvent();
        this.setState({
            loaderFlag: true
        });
    }
    TabClick = (index) => {
        this.setState({
            activetab: index
        })
    }

    getHowToFestHeaderEvent = () => {
        sub = this.apiserve.getevent().subscribe(response => {
            switch (response.event) {
                case 'howToFestOnline|header|getDetail':
                    if (!response.error) {
                        if (this.state.description) {
                            const blocksFromHtml = htmlToDraft(response.data.description ? response.data.description : '');
                            const { contentBlocks, entityMap } = blocksFromHtml;
                            const contentState = ContentState.createFromBlockArray(
                                contentBlocks,
                                entityMap
                            );
                            const description = EditorState.createWithContent(contentState);
                            this.setState({
                                description: description
                            })
                        }
                        this.setState({
                            getAllHowToFestHeaderdetails: response.data,
                            error: response.data.error,
                            loaderFlag: false,
                            title: response.data.title,
                            inSite: response.data && response.data.media && response.data.media.inSite ? response.data.media.inSite : this.state.inSite,
                            link: response.data && response.data.media && response.data.media.link ? response.data.media.link : this.state.link
                        })
                    }
                    break;
                case 'howToFestOnline|header|create':
                    if (response.error === true) {
                        this.setState({
                            loaderFlag: false,
                            errorMsg: true,
                            errorMsgShow: response.data.error,
                        });
                    } else {
                        this.setState({ loaderFlag: false }, () => {
                            this.apiserve.success("howToFestOnline Header updated successful.")
                        });
                        this.getHowToFestHeader()
                    }
                    break;
                case 'howToFestOnline|getLastUpdated':
                    this.setState({
                        getLastUpdated: response.data
                    })
                    break;
            }
        })
    }

    handleVideo = (e) => {
        e.stopPropagation()
        e.preventDefault();
        let file = e.target.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onloadend = (event) => {
            this.setState({
                file: file,
                // base64: reader.result
            }, () => {
                this.videoUp.value = "";

                if (file.size > 100e6) {

                    this.setState({
                        errorMsg: true,
                        errorMsgShow: 'Please upload a video smaller than 100 MB'
                    })
                    return false;
                }

                if (file.type === 'video/mp4') {
                    setTimeout(() => {
                        this.videoUpload(file,event.target.result);
                    }, 1000)
                } else {
                    this.setState({
                        errorMsg: true,
                        errorMsgShow: 'Please upload only MP4 file'
                    })
                }

            })
        }
    }

    videoUpload = (file, img) => {
        this.setState({ videoPreLoader: true })
        var fileSet = commonImage(file,false,'',img)
        fileSet.then((value) => {
                this.setState({
                    videoPreLoader: false,
                    inSite: value,
                    link: ''
                });
            });
    };

    getHowToFestHeader = () => {
        this.apiserve.sendevent("howToFestOnline|header|getDetail", {});
        this.apiserve.sendevent("howToFestOnline|getLastUpdated", { type: 'OnlineHeader' });
    }

    onEditorStateChange = (description) => {
        this.setState({
            description: description
        });
    };

    handelChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
            inSite: ''
        })
    }

    submitFn = async (e) => {
        e.preventDefault();
        if (this.validator.allValid()) {
            let media = []
            this.setState({ loaderFlag: true });
            const name = convertToRaw(this.state.description.getCurrentContent())
            const markup = draftToHtml(name)
            // const media = {
            //     inSite: this.state.inSite,
            //     link: this.state.link
            // }
            media[0] = {
                inSite: this.state.inSite,
                link: this.state.link
            }
            let updateHowToFest = {
                id: this.state._id,
                title: this.state.title,
                description: markup,
                media: media
            }
            this.apiserve.sendevent("howToFestOnline|header|create", updateHowToFest);
        }
    }

    validateModel = () => {
        this.setState({
            errorMsg: false,
        });
    };

    setDeleteImagePopup = () => {
        this.setState({
            deleteImagePopup: true
        })
    }
    onDeleteImagePopup = () => {
        this.setState({
            inSite: '',
            deleteImagePopup: false
        })
    }
    closeAdminUser = () => {
        this.setState({ deleteImagePopup: false })
    };

    previewRecordHTF = (e) => {
        e.preventDefault()
        let updateHowToFest = {}
        if (this.validator.allValid()) {
            let media = []
            // this.setState({ loaderFlag: true });
            const name = convertToRaw(this.state.description.getCurrentContent())
            const markup = draftToHtml(name)
            // const media = {
            //     inSite: this.state.inSite,
            //     link: this.state.link
            // }
            media[0] = {
                inSite: this.state.inSite,
                link: this.state.link
            }
            updateHowToFest = {
                id: this.state._id,
                title: this.state.title,
                description: markup,
                media: media,
                tabData: 'howToFestOnline',
                tabIndex: 7,
            }
        }
        let previewRecordEvents = this.apiserve.encrypt(updateHowToFest)
        window.open(process.env.REACT_APP_FRONTEND_ORIGIN_HTF + 'htf-online-preview?data=' + previewRecordEvents);
        // this.setState({ loaderFlag: false });
    }

    render() {
        const { getLastUpdated } = this.state;
        var updateAt = new Date(getLastUpdated && getLastUpdated.updatedAt);
        var hour = moment.tz(updateAt, "US/Mountain").format("h");
        var minutes = moment.tz(updateAt, "US/Mountain").format("mm");
        var state = moment.tz(updateAt, "US/Mountain").format("A");
        var updatedBy = getLastUpdated && getLastUpdated.updatedBy;
        return (
            <React.Fragment>
                <div className="right_side_wrapper artistView_wrapper">
                    <ul className="fpg_admin_tab disp_flex">
                        {
                            this.state.data && this.state.data.map((list, index) => {
                                return (
                                    <li className="active" key={index}>
                                        <p className="uppercase text_left">
                                            <div>{list.label}</div>
                                        </p>
                                    </li>
                                )
                            })
                        }
                    </ul>
                    <div className="back_date d_flex d_flex_align_center d_flex_justify_spacebt">
                        <p></p>
                        <p className="update_date">Last Update: {hour}:{minutes} {state} - {moment.tz(updateAt, "US/Mountain").format("MM/DD/YYYY")} Last Updated
                            By: {updatedBy && updatedBy.fname} {updatedBy && updatedBy.lname}</p>
                    </div>
                    <div className="fest_contents fpg_tabcontent">
                        <form>
                            <div className="d_flex">
                                <div className="header_left">
                                    <div className="field_row horizontal_field">
                                        <TextField type="text" label="Header Title" name="title" value={this.state.title} onChange={this.handelChange} />
                                    </div>
                                    <div className="field_row horizontal_field">
                                        <div className="field_row_inner">
                                            <label>Header Description </label>
                                            <div className="field_input editor_wrapper">
                                                <TextEditor editorState={this.state.description} name="description" value={this.state.description} onEditorStateChange={this.onEditorStateChange} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="header_vid video_slider uploads_files">
                                    {/* Video */}
                                    <div className="form_group common_video_upload">
                                        <div className="form_group_inner">
                                            <label className="font_500 mb_5">Header Video</label>
                                            <div className="form_group_video loader-main">
                                                <span className="form_note">Upload mp4 of max size of 100MB</span>
                                                {/* <img className="uploaded_img" src="https://wowslider.net/local-sliders/demo-10/data1/images/road220058.jpg" /> */}
                                                <div className="form_group_video_wpr">
                                                    {this.state.videoPreLoader ?
                                                        <Loader />
                                                        :
                                                        <>
                                                        <Player
                                                            playsInline
                                                            autoPlay={false}
                                                            type="video/mp4"
                                                            // src={this.apiserve.imageUrl +  this.state.homeVideo}
                                                            src={this.state.inSite ? this.apiserve.imageUrl + this.state.inSite : this.state.link ? this.state.link : ''}
                                                        >
                                                            <ControlBar autoHide={false} disableDefaultControls={true}>
                                                                <PlayToggle />
                                                            </ControlBar>
                                                        </Player>
                                                        </>
                                                    }
                                                </div>
                                                <span className={this.state.inSite ? "input_file active" : "input_file"}>
                                                    <input name="homeVideo"
                                                        id="myInput"
                                                        type="file"
                                                        ref={(ref) => this.videoUp = ref}
                                                        onChange={this.handleVideo.bind(this)}
                                                        className="file-upload"
                                                        accept=".mp4"
                                                    />
                                                    <PlusIcon className="video_add_icon" onClick={() => { this.videoUp.click() }} />

                                                </span>
                                                {this.state.inSite === '' ? '' :
                                                    <span className="remove_file pointer "
                                                        onClick={() => this.setDeleteImagePopup()}
                                                    ><DeletefileIcon /></span>
                                                }
                                                {/* <VideoOnlyUpload
                                                        index={''}
                                                        handleVideo={(e) => this.handleVideo(e)}
                                                        insideOnchange={(e) => this.handelChange(e)}
                                                        url={this.state.inSite ? this.apiserve.imageUrl + this.state.inSite : this.state.link}
                                                        video={this.state.inSite ? this.apiserve.imageUrl + this.state.inSite : this.state.link}
                                                        videoUrl={this.state.link}
                                                        item={this.state.inSite}
                                                        iconDelete={true}
                                                        showDeleteIcon={this.state.inSite ? true : false}
                                                        videoPreLoader={this.state.videoPreLoader} 
                                                        deleteVideo={(e) => this.setDeleteImagePopup()}
                                                        uploadmessage="Upload mp4 of max size of 100MB"
                                                    /> */}
                                            </div>
                                        </div>
                                        <div className="field_row">
                                            <div className="field_input relative">
                                                <input
                                                    type="text"
                                                    placeholder="https://cloudfront.aws.com/sdf2345"
                                                    name='link'
                                                    value={this.state.link}
                                                    onChange={this.handelChange}
                                                />
                                                <span className="copy_box">
                                                    <CopyIcon />
                                                </span>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                                <div className="text_center field_row w_100 buttons_outer">
                                    <button className="uppercase">CANCEL</button>
                                    {/* <button className="uppercase prev_btn">PREviEW</button> */}
                                    <button className="uppercase prev_btn" type='button' onClick={(e) => this.previewRecordHTF(e)}>PREviEW</button>
                                    <button className="uppercase active" type="button" onClick={this.submitFn}>SAVE</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div className={`user_popup ${this.state.errorMsg ? "active" : ""}`}>
                    <span className="popup_overlay"></span>
                    <div className="sundance_popup_detail box_shadow approve_success_popup bg_white">
                        <div className="approve_popup_header text_center relative">
                            <p>{this.state.errorMsgShow}</p>
                        </div>
                        <div className="content">
                            <div className="field_row text_center">
                                <button
                                    className="small_btn active"
                                    onClick={this.validateModel}
                                >
                                    OK
                                    </button>
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.loaderFlag ? <Loader /> : ""}
                {this.state.deleteImagePopup
                    ? <PopUpCustomAll
                        HeaderName="Delete Image?"
                        insideDetails="Are You Sure ?"
                        insideData="You want to delete this image"
                        popupState={() => this.closeAdminUser()}
                        yesPopUp={() => this.onDeleteImagePopup()} />
                    : ""
                }
            </React.Fragment>
        )
    }
}
